import { useEffect, useState } from 'react';

/**
 * Devuelve una versión "retrasada" de `value` que solo se actualiza cuando el
 * valor deja de cambiar durante `delay` ms. Útil para no disparar una consulta
 * por cada tecla (p. ej. sugerencias mientras se tipea).
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
